import { Controller } from "@hotwired/stimulus"

// Formularz definicji pola własnego: podgląd klucza-sluga na żywo z etykiety (transliteracja
// polskich znaków), sekcja opcji widoczna tylko dla typu select, dodawanie/usuwanie opcji.
export default class extends Controller {
  static targets = ["label", "key", "kind", "optionsSection", "optionsList", "optionTemplate", "integerHint", "multipleSection"]

  connect() {
    // klucz edytowany ręcznie przestaje podążać za etykietą; readonly (edycja) nie ruszamy
    this.keyTouched = this.keyTarget.readOnly || this.keyTarget.value.trim() !== ""
    this.kindChanged()
  }

  labelChanged() {
    if (this.keyTouched) return
    this.keyTarget.value = this.slugify(this.labelTarget.value)
  }

  keyEdited() {
    this.keyTouched = this.keyTarget.value.trim() !== ""
  }

  kindChanged() {
    const isSelect = this.kindTarget.value === "select"
    this.optionsSectionTarget.hidden = !isSelect
    this.optionsSectionTarget.querySelectorAll("input").forEach((el) => {
      el.disabled = !isSelect
    })
    if (isSelect && this.optionsListTarget.children.length === 0) this.addOption()
    if (this.hasIntegerHintTarget) this.integerHintTarget.hidden = this.kindTarget.value !== "integer"

    // opcja "wiele wartości" (multiple) dotyczy tylko selecta - poza nim chowamy i odznaczamy
    if (this.hasMultipleSectionTarget) {
      this.multipleSectionTarget.hidden = !isSelect
      const checkbox = this.multipleSectionTarget.querySelector("input[type=checkbox]")
      if (checkbox) {
        checkbox.disabled = !isSelect
        if (!isSelect) checkbox.checked = false
      }
    }
  }

  addOption() {
    this.optionsListTarget.insertAdjacentHTML("beforeend", this.optionTemplateTarget.innerHTML)
    const rows = this.optionsListTarget.querySelectorAll("[data-option-row]")
    rows[rows.length - 1].querySelector("input[type=text]").focus()
  }

  removeOption(event) {
    event.target.closest("[data-option-row]").remove()
  }

  // Transliteracja polskich znaków + slug (podgląd; serwer i tak liczy klucz gdy pusty)
  slugify(text) {
    const map = { ą: "a", ć: "c", ę: "e", ł: "l", ń: "n", ó: "o", ś: "s", ź: "z", ż: "z" }
    return text
      .toLowerCase()
      .replace(/[ąćęłńóśźż]/g, (ch) => map[ch])
      .replace(/[^a-z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "")
      .replace(/^[0-9]+/, "")
      .slice(0, 50)
  }
}
